export const environment = {
  production: false,
  host: 'https://test-api.aedawallet.com/api',
};
